import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAppState, IPreAuthenState } from '../shared/models/store.model'
import { logOutApp } from '.'

const initialState: IPreAuthenState = {
  userName: '',
  password: '',
  otp: '',
  email: '',
  currentPassword: '', //optional
  newPassword: '',
  confirmNewPassword: '',
}

const preAuthenReducer = createSlice({
  name: 'preAuthen',
  initialState,
  reducers: {
    updatePreAuthenInfo(state: IPreAuthenState, action: PayloadAction<IPreAuthenState>) {
      return { ...state, ...action.payload }
    },

    increaseCountOtpSent(state: IPreAuthenState) {
      state.countOtpSent = (state.countOtpSent ?? 0) + 1
    },

    resetCountOtpSent(state: IPreAuthenState) {
      state.countOtpSent = 0
    },

    clearPreAuthenInfo(state: IPreAuthenState) {
      state.userName = ''
      state.password = ''
      state.otp = ''
      state.countOtpSent = 0
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(logOutApp, () => {
      return initialState
    })
  },
})

const rootState = (state: IAppState) => state.preAuthen

export const getPreAuthenInfo = createSelector(rootState, (state: IPreAuthenState) => state)

export const { updatePreAuthenInfo, increaseCountOtpSent, clearPreAuthenInfo, resetCountOtpSent } =
  preAuthenReducer.actions

export default preAuthenReducer
